import { createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "revico-api-master" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createCommentVNode(" APIローディング状態に表示するコンテンツ "),
    ($setup.props.status === $setup.ApiGetLoadStatus.loading)
      ? _renderSlot(_ctx.$slots, "loading", { key: 0 }, () => [
          _createVNode($setup["ApiLoadingDisplay"])
        ])
      : ($props.status === $setup.ApiGetLoadStatus.success)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createCommentVNode(" API成功時に表示するコンテンツ "),
            _renderSlot(_ctx.$slots, "contents")
          ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
        : ($props.status === $setup.ApiGetLoadStatus.error && !$setup.isExistErrorSlot())
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createCommentVNode(" API失敗時に表示するコンテンツ "),
              _createVNode($setup["ApiErrorDisplay"])
            ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
          : _createCommentVNode("v-if", true),
    ($props.status === $setup.ApiGetLoadStatus.error)
      ? _renderSlot(_ctx.$slots, "error", { key: 3 })
      : _createCommentVNode("v-if", true)
  ]))
}